module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/allotment-cancellation/project-list/project-list.component.css
// module id = ./src/app/allocation/allotment-cancellation/project-list/project-list.component.css
// module chunks = main